import { useState } from "react";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import Modaltooltip from "../../../../../common/Modaltooltip";

import SnackbarComponent from "../../../../../common/SnackbarPopup";

import Prism from "prismjs";
import "prismjs/themes/prism-tomorrow.css"; // or another theme

interface ImageTextObject {
  image: string;
  text: string;
  sourceCode: string;
  description: string;
}
interface ElementContextProps {
  imageTextArray: ImageTextObject[];
}

type frameworkOption = {
  label: string;
  value: string;
};
export default function ElementModal({
  imageTextArray,
}: ElementContextProps): JSX.Element {
  const [modal, setModal] = useState<boolean>(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState(
    "Copied to clipboard 🎉"
  );
  const [copied, setCopied] = useState(false);

  const [activeComponent, setActiveComponent] =
    useState<ImageTextObject | null>(null);

  const reactOptions: frameworkOption[] = [
    { label: "JavaScript", value: "JavaScript" },
    { label: "TypeScript", value: "Typescript" },
  ];

  // Modal
  const handleClick = (element: ImageTextObject) => {
    setModal(true);
    setActiveComponent(element);
  };
  const handleClose = () => {
    setModal(false);
  };

  return (
    <>
      <div className="layout_component_wrapper">
        {imageTextArray.map((element, index) => (
          <section key={index}>
            <div
              className="layout_component"
              onClick={() => handleClick(element)}
            >
              <div className="layout_component__inner">
                <>
                  <img src={`${element.image}`} alt="" />
                  <span className="layout_component__text">{element.text}</span>
                </>
              </div>
            </div>
            {/* Modal */}
            {modal && activeComponent && activeComponent == element && (
              <>
                <div className="modal-overlay">
                  <div className="modal-bg" onClick={handleClose}></div>
                  <div className="modal">
                    {/* Heading */}
                    <section className="modal-heading">
                      <div className="modal-heading_inner">
                        <h4 className="modal-intro">Generate code</h4>
                        <div className="modal-cancel-btn" onClick={handleClose}>
                          <span className="cancel-line"></span>
                          <span className="cancel-line"></span>
                        </div>
                      </div>
                    </section>

                    {/* Code preview */}
                    <div className="modalPreview">
                      <div className="code-preview-header">
                        <div className="editor-dots">
                          <span className="dot dot-red"></span>
                          <span className="dot dot-yellow"></span>
                          <span className="dot dot-green"></span>
                        </div>
                        <div
                          className="copy-icon"
                          onClick={() => {
                            navigator.clipboard.writeText(
                              activeComponent.sourceCode
                            );
                            setSnackbarMessage("Copied to clipboard 🎉");
                            setOpenSnackbar(true);
                          }}
                          title="Copy"
                        >
                          <ContentCopyIcon style={{ color: "#aaa" }} />
                        </div>
                      </div>
                      <div className="modalPreview__code">
                        <pre className="previewCode">
                          <code
                            dangerouslySetInnerHTML={{
                              __html: Prism.highlight(
                                activeComponent.sourceCode,
                                Prism.languages.javascript,
                                "javascript"
                              ),
                            }}
                          />
                        </pre>
                      </div>
                    </div>

                    <section className="modal-info">
                      <span className="divider"></span>

                      <div className="modal-info_inner">
                        {/* Heading */}
                        <div className="modal-info__heading">
                          <h4 className="modal-info__head"> {element.text} </h4>
                          <p className="modal-info__explanation">
                            {element.description}
                          </p>
                        </div>
                        {/* Framework-1 */}
                        <div className="select-framework">
                          <div className="select-framework_head">
                            {" "}
                            <p> List of React framework</p>
                            <ArrowDropDownIcon
                              fontSize="medium"
                              className="arrow-icon"
                            />
                          </div>
                          <div className="select-framework__options">
                            {reactOptions.map((option) =>
                              option.label === "JavaScript" ? (
                                <div
                                  key={option.value}
                                  className="option option-active"
                                  onClick={() => {
                                    navigator.clipboard.writeText(
                                      element.sourceCode
                                    );
                                    setSnackbarMessage(
                                      "Copied to clipboard 🎉"
                                    );
                                    setOpenSnackbar(true);
                                  }}
                                >
                                  {option.label}
                                </div>
                              ) : (
                                <div
                                  key={option.value}
                                  className="option"
                                  onClick={() => {
                                    setSnackbarMessage("Coming Soon ✌️");
                                    setOpenSnackbar(true);
                                  }}
                                  style={{
                                    color: "gray",
                                    cursor: "pointer",
                                    opacity: 0.5,
                                  }}
                                >
                                  {option.label}
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                    </section>
                    {/* generate button */}
                    {/* <div className="button_container">
                      <button className="generate_button">Edit Code </button>
                    </div> */}
                    {/* End of modal info */}
                  </div>
                </div>
              </>
            )}
          </section>
        ))}
      </div>

      <SnackbarComponent
        openSnackbar={openSnackbar}
        setOpenSnackbar={setOpenSnackbar}
        snackbarMessage={snackbarMessage}
      />
    </>
  );
}

// const imageTextArray: ElementContextProps[] = [{ image: [], text: [] }]
